import { __exports as updater } from "../../../../../../_virtual/updater.js";
import { __require as requireLoglevel } from "../types/loglevel.js";
import { __require as requireCohort } from "../util/cohort.js";
import { __require as requireLogger } from "../util/logger.js";
var hasRequiredUpdater;
function requireUpdater() {
  if (hasRequiredUpdater) return updater;
  hasRequiredUpdater = 1;
  var __awaiter = updater && updater.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  Object.defineProperty(updater, "__esModule", { value: true });
  updater.FlagConfigUpdaterBase = void 0;
  const loglevel_1 = requireLoglevel();
  const cohort_1 = requireCohort();
  const logger_1 = requireLogger();
  class FlagConfigUpdaterBase {
    constructor(cache, cohortStorage, cohortFetcher, logLevel = loglevel_1.LogLevel.Error, loggerProvider = new logger_1.ConsoleLogger()) {
      this.cache = cache;
      this.cohortFetcher = cohortFetcher;
      this.cohortStorage = cohortStorage;
      this.logger = new logger_1.AmplitudeLogger(logLevel, loggerProvider);
    }
    _update(flagConfigs, onChange) {
      return __awaiter(this, void 0, void 0, function* () {
        let changed = false;
        if (onChange) {
          const current = yield this.cache.getAll();
          if (!Object.is(current, flagConfigs)) {
            changed = true;
          }
        }
        const cohortIds = cohort_1.CohortUtils.extractCohortIds(flagConfigs);
        if (cohortIds && cohortIds.size > 0 && !this.cohortFetcher) {
          this.logger.error("Cohorts found in flag configs but no cohort download configured");
        } else {
          yield this.downloadNewCohorts(cohortIds);
        }
        yield this.cache.clear();
        yield this.cache.putAll(flagConfigs);
        yield this.removeUnusedCohorts(cohortIds);
        if (changed) {
          yield onChange(this.cache);
        }
      });
    }
    downloadNewCohorts(cohortIds) {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        const oldCohortIds = (_a = this.cohortStorage) === null || _a === void 0 ? void 0 : _a.getAllCohortIds();
        const newCohortIds = cohort_1.CohortUtils.setSubtract(cohortIds, oldCohortIds);
        const failedCohortIds = /* @__PURE__ */ new Set();
        const cohortDownloadPromises = [...newCohortIds].map((cohortId) => {
          var _a2;
          return (_a2 = this.cohortFetcher) === null || _a2 === void 0 ? void 0 : _a2.fetch(cohortId).then((cohort) => {
            if (cohort) {
              this.cohortStorage.put(cohort);
            }
          }).catch((err) => {
            this.logger.error(`[Experiment] Cohort download failed ${cohortId}`, err);
            failedCohortIds.add(cohortId);
          });
        });
        yield Promise.all(cohortDownloadPromises);
        return failedCohortIds;
      });
    }
    removeUnusedCohorts(validCohortIds) {
      return __awaiter(this, void 0, void 0, function* () {
        const cohortIdsToBeRemoved = cohort_1.CohortUtils.setSubtract(this.cohortStorage.getAllCohortIds(), validCohortIds);
        cohortIdsToBeRemoved.forEach((id) => {
          this.cohortStorage.delete(id);
        });
      });
    }
  }
  updater.FlagConfigUpdaterBase = FlagConfigUpdaterBase;
  return updater;
}
export {
  requireUpdater as __require
};
//# sourceMappingURL=updater.js.map
